import React from 'react'

function Line({ colorCode, classDotted }) {
    return (
        <svg className={`MuiSvgIcon-root ${classDotted}`} viewBox="0 0 89 1">
            <line x1="-4.37114e-08" y1="0.5" x2="89" y2="0.499992" stroke={colorCode} strokeOpacity="0.7" strokeDasharray="5 5" />
        </svg>
    )
}

export default Line
